//export const AuthURL = 'http://sandra.ozip.co.id/api/auth/'; // 3000
//export const DonorURL = 'http://sandra.ozip.co.id/api/dono/'; // 3001
//export const MasterDataURL = 'http://sandra.ozip.co.id/api/mastd/'; // 3002
//export const DonationURL = 'http://sandra.ozip.co.id/api/dona/'; // 3003
//export const DonaturURL =  'http://donatur.dev.ozip.co.id/api/'; // 3010

export const AuthURL = `${process.env.REACT_APP_REST_API_URL}/auth/`;
export const DonorURL = `${process.env.REACT_APP_REST_API_URL}/donor/`;
export const MasterDataURL = `${process.env.REACT_APP_REST_API_URL}/master_data/`;
export const SuperAdminURL = `${process.env.REACT_APP_REST_API_URL}/superadmin/`;
export const BenefisURL = `${process.env.REACT_APP_REST_API_URL}/benefis/`;
export const DonationURL = `${process.env.REACT_APP_REST_API_URL}/donation/`;
export const KurbanURL = `${process.env.REACT_APP_REST_API_URL}/kurban/`;
export const PublicReportURL = `${process.env.REACT_APP_REST_API_URL}/report/`;
export const OrganizationURL = `${process.env.REACT_APP_REST_API_URL}/organization/`;
export const NotificationOrgURL = `${process.env.REACT_APP_REST_API_URL}/notification_organization/`;
export const CertURL = `${process.env.REACT_APP_REST_API_URL}/report/certificate-kurban/`;
export const CampaignURL = `${process.env.REACT_APP_REST_API_URL}/campaign/`;

// export const AuthURL = 'http://localhost:3000/';
// export const DonorURL = 'http://localhost:3001/';
// export const MasterDataURL = 'http://localhost:3002/';
// export const DonationURL = 'http://localhost:3003/';
// export const DonaturURL = 'http://localhost:3010/';
// export const PublicReportURL = "http://localhost:3005/"
